import styled from 'styled-components';
import { TableWitPagination } from 'dash-ui';

export const StyledTable = styled(TableWitPagination)`
  table tr {
    min-height: ${({ theme }) => theme.space * 6}px;
  }
`;
